import { Component, OnDestroy, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import moment from 'moment';
import { Observable } from 'rxjs';
import * as fromDataServices from '../../data-services';
import * as fromShared from '../../shared';
import { LoggingService } from '../../shared/services/logging';
import { map, takeWhile } from 'rxjs/operators';
@Component({
    selector: 'ef-email-audit-container',
    templateUrl: './email-audit-container.component.html',
    styleUrls: ['./email-audit-container.component.scss'],
    standalone: false
})
export class EmailAuditContainerComponent implements OnInit, OnDestroy {
    process$: Observable<fromShared.Process>;
    EmailAuditModelDS: EntityCollectionService<fromDataServices.EmailAudit.EmailAuditModel>;
    EmailAuditModel$: Observable<fromDataServices.EmailAudit.EmailAuditModel[]>;
    active = true;
    constructor(
        private log: LoggingService,
        public entityServices: EntityServices,
        private store: Store
    ) {
        this.log.verbose({ type: 'EmailAuditContainerComponent::' });
        this.EmailAuditModelDS =
            entityServices.getEntityCollectionService<fromDataServices.EmailAudit.EmailAuditModel>(
                fromDataServices.EmailAudit.entityName
            );
    }
    ngOnInit(): void {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));

        this.EmailAuditModelDS.clearCache();
        //this.EmailAuditModel$ = this.EmailAuditModelDS.entities$;
        this.setupObservables();
    }
    ngOnDestroy() {
        this.active = false;
    }
    onDateFiltersChanged($event: { startDate: Date; endDate: Date }) {
        this.log.verbose({
            type: 'EmailAuditContainerComponent:onDateFiltersChanged',
            $event
        });
        this.EmailAuditModelDS.clearCache();
        this.EmailAuditModelDS.getWithQuery({
            EndDate: moment(moment($event.endDate).format('L'))
                .add(1, 'day')
                .format('L'),
            StartDate: moment($event.startDate).format('L')
        });
    }
    setupObservables() {
        this.EmailAuditModel$ = this.EmailAuditModelDS.entities$.pipe(
            map(x => x.sort((a, b) => new Date(b.MessageDate).getTime() - new Date(a.MessageDate).getTime()))
        );
    }
}
